import SuggestionItem from './SuggestionItem'

export default SuggestionItem
